import { render, staticRenderFns } from "./ManutencaoCatalogoServico.vue?vue&type=template&id=646545e8&scoped=true&"
import script from "./ManutencaoCatalogoServico.vue?vue&type=script&lang=js&"
export * from "./ManutencaoCatalogoServico.vue?vue&type=script&lang=js&"
import style0 from "./ManutencaoCatalogoServico.vue?vue&type=style&index=0&id=646545e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646545e8",
  null
  
)

export default component.exports